import { get, pickBy, reduce, set } from "lodash-es";
import { walkLayout } from "../../../lib/utils";
import { searchKeyInObjectDeep, searchStringInStringArray } from "../../../lib/utils/searchPagelet/util";
import { EventTranslatePlugin } from './TranslateEventsPlugin';
/** 历史遗留? 破碎的翻译 */
const specTranslate = {
  displayCondition: '按条件决定是否可见',
  renderCondition: '按条件实例化组件'
};
export class SearchAnsGroupClass {
  constructor({
    object,
    searchAns,
    ansArray
  }) {
    this.done = false;
    this.object = object;
    this.searchAns = searchAns;
    this.ansArray = ansArray || [];
  }
  transferFromGenerator(num) {
    if (this.done) return 0;
    for (let i = 0; i < num; ++i) {
      const next = this.searchAns.next();
      if (next.done) {
        this.done = true;
        return i + 1;
      }
      this.ansArray.push(next.value);
    }
    return num;
  }
}
function flatStates(pageletWalks) {
  return pageletWalks.map(pageletWalk => {
    var _pageletWalk$pagelet;
    return ((_pageletWalk$pagelet = pageletWalk.pagelet) === null || _pageletWalk$pagelet === void 0 || (_pageletWalk$pagelet = _pageletWalk$pagelet.stateSchema) === null || _pageletWalk$pagelet === void 0 || (_pageletWalk$pagelet = _pageletWalk$pagelet.fields) === null || _pageletWalk$pagelet === void 0 ? void 0 : _pageletWalk$pagelet.map(field => ({
      sourcePath: pageletWalk.sourcePath,
      object: field
    }))) || [];
  }).flat().filter(Boolean);
}
function flatTriggers(pageletWalks) {
  return pageletWalks.map(pageletWalk => {
    var _pageletWalk$pagelet2;
    return ((_pageletWalk$pagelet2 = pageletWalk.pagelet) === null || _pageletWalk$pagelet2 === void 0 || (_pageletWalk$pagelet2 = _pageletWalk$pagelet2.triggers) === null || _pageletWalk$pagelet2 === void 0 ? void 0 : _pageletWalk$pagelet2.map((value, index) => ({
      sourcePath: `${pageletWalk.sourcePath}/triggers/${index}`,
      compPath: `/@triggers/${index}`,
      layout: value,
      slotId: ''
    }))) || [];
  }).flat().filter(Boolean);
}
/** pagelet2pageletWalk */
function pagelet2PageletWalk(pagelet) {
  const compList = [];
  const pageletWalks = [];
  walkLayout(pagelet.layout, layoutStep => {
    compList.push(layoutStep);
  }, {
    includeScopedSlots: true,
    pageletHandler: p => pageletWalks.push(p)
  });
  pageletWalks.unshift({
    pagelet,
    sourcePath: ''
  });
  const res = {
    id: pagelet.id,
    comps: compList || [],
    states: flatStates(pageletWalks) || [],
    props: get(pagelet, 'propsSchema.fields') || [],
    querys: get(pagelet, 'querySchema.fields') || [],
    triggers: flatTriggers(pageletWalks) || [],
    xySources: get(pagelet, 'xySources') || [],
    lessCode: (pagelet === null || pagelet === void 0 ? void 0 : pagelet.lessCode) || ''
  };
  return res;
}
/** 搜索单个pagelet中的内容 期望和ucRender的生命周期同步 或者在切换页面时手动刷新pagelet
 * 为
 * */
export class SearchInPageLet {
  constructor(pagelet, ucBus, options) {
    this.translateMap = new Map();
    // TODO: 补全其他的搜索回调
    this.searchSolveCb = {
      comps: this.searchInComps,
      states: this.searchInWalkObjects,
      props: this.searchInObjects,
      querys: this.searchInObjects,
      triggers: this.searchTriggers,
      xySources: this.searchInObjects,
      lessCode: this.searchInString
    };
    this.searchInput = '';
    this.searchConfig = {
      MatchCase: false,
      UseReg: false,
      ShowDefault: false,
      AllowSearchEmptyString: false
    };
    this.translatePluginList = [];
    this.pagelet = pagelet;
    this.ucBus = ucBus;
    this.searchConfig = {
      ...this.searchConfig,
      ...options
    };
    this.translatePluginList = (options === null || options === void 0 ? void 0 : options.translatePlugins) || [];
    this.prepareTranslate();
  }
  updatePageLet(pagelet) {
    this.pagelet = pagelet;
  }
  getPageLetSearch(pagelet = this.pagelet) {
    return this.searchPageLet(pagelet2PageletWalk(pagelet));
  }
  getPageLetSearchWithGeneratorNotEmpty() {
    const res = this.searchPageLet(pagelet2PageletWalk(this.pagelet));
    Object.entries(res).forEach(([key, value]) => {
      // eslint-disable-next-line max-len
      res[key] = value.filter(obj => obj.searchAns.next().done === false);
    });
    return res;
  }
  /** 按照searchSolveCb对pagelet中多种路径进行搜索 */
  searchPageLet(walk) {
    const searchAnsAll = {};
    Object.entries(this.searchSolveCb).forEach(([key, cb]) => {
      var _this$searchConfig;
      // 输入空串并且不允许搜索空串
      if (!this.searchInput && !this.searchConfig.AllowSearchEmptyString) {
        searchAnsAll[key] = [];
        return;
      }
      // 可以去过滤自己想要的部分进行搜索
      if (this.searchConfig.filterSearchPath && !((_this$searchConfig = this.searchConfig) !== null && _this$searchConfig !== void 0 && (_this$searchConfig = _this$searchConfig.filterSearchPath) !== null && _this$searchConfig !== void 0 && _this$searchConfig.includes(key))) return;
      searchAnsAll[key] = cb.bind(this)(walk[key]);
    });
    return searchAnsAll;
  }
  /** 搜索组件 */
  searchInComps(comps) {
    return comps.map(comp =>
    // 对单个组件进行搜索
    this.searchComps(comp));
  }
  get componentsLUT() {
    return this.ucBus.components || {};
  }
  get componentsArray() {
    return this.ucBus.componentsArray || [];
  }
  get flowAtomsArray() {
    return this.ucBus.flowAtomsArray || [];
  }
  /** atomid : atomname */
  get translateFlow() {
    let translateFlow = {};
    this.flowAtomsArray.forEach(atom => {
      translateFlow[atom.id] = atom.name;
    });
    translateFlow = pickBy(translateFlow);
    return translateFlow;
  }
  /** fieldid : fieldtitle    eventid : eventname   eventasProp : eventname */
  getTranslateProp(comp) {
    var _comp$propsSchema, _comp$querySchema, _comp$events;
    const translateProp = {};
    // @ts-ignore
    comp === null || comp === void 0 || (_comp$propsSchema = comp.propsSchema) === null || _comp$propsSchema === void 0 || (_comp$propsSchema = _comp$propsSchema.fields) === null || _comp$propsSchema === void 0 || _comp$propsSchema.forEach(field => {
      translateProp[field.id] = field.title;
    });
    // @ts-ignore
    comp === null || comp === void 0 || (_comp$querySchema = comp.querySchema) === null || _comp$querySchema === void 0 || (_comp$querySchema = _comp$querySchema.fields) === null || _comp$querySchema === void 0 || _comp$querySchema.forEach(field => {
      translateProp[field.id] = field.title;
    });
    // @ts-ignore
    comp === null || comp === void 0 || (_comp$events = comp.events) === null || _comp$events === void 0 || _comp$events.forEach(event => {
      if (event.asProp && event.name) translateProp[`:${event.asProp}`] = event.name;else if (event.id && event.name) {
        translateProp[event.id] = event.name;
      }
    });
    return pickBy(translateProp);
  }
  /** 翻译enum中的 value : label */
  getValueTranslate(comp) {
    var _comp$propsSchema2;
    const valueTranslate = {};
    comp === null || comp === void 0 || (_comp$propsSchema2 = comp.propsSchema) === null || _comp$propsSchema2 === void 0 || (_comp$propsSchema2 = _comp$propsSchema2.fields) === null || _comp$propsSchema2 === void 0 || _comp$propsSchema2.forEach(field => {
      var _field$enum;
      field === null || field === void 0 || (_field$enum = field.enum) === null || _field$enum === void 0 || _field$enum.forEach(({
        label,
        value
      }) => {
        valueTranslate[value] = label;
      });
    });
    return pickBy(valueTranslate);
  }
  /** 缓存翻译数组 */
  prepareTranslate() {
    this.translateMap = new Map();
    this.componentsArray.forEach(comp => {
      const compType = comp.id;
      this.translateMap.set(compType, {
        translateFlow: this.translateFlow,
        translateProp: this.getTranslateProp(comp),
        valueTranslate: this.getValueTranslate(comp)
      });
    });
  }
  /** 根据defaultProps生成默认值 补充到layout中 */
  completeDefaultProps(layoutIn) {
    const layout = {
      ...layoutIn
    };
    const {
      type
    } = layout;
    // 补全layout的默认值
    const compMeta = get(this.componentsLUT, type);
    layout.props = {
      ...(compMeta === null || compMeta === void 0 ? void 0 : compMeta.defaultProps),
      ...layout.props
    };
    const eventAll = compMeta === null || compMeta === void 0 ? void 0 : compMeta.events;
    if (eventAll) {
      const events = reduce(eventAll, (obj, val) => ({
        ...obj,
        [val.asProp ? `:${val.asProp}` : val.id]: '未配置'
      }), {});
      layout.events = {
        ...events,
        ...layout.events
      };
    }
    return layout;
  }
  /** cmp函数 */
  matchKey(source, target) {
    let sourceStr = String(source);
    let targetStr = String(target);
    if (!this.searchConfig.MatchCase) {
      sourceStr = sourceStr.toLowerCase();
      targetStr = targetStr.toLowerCase();
    }
    if (this.searchConfig.UseReg) {
      return sourceStr.search(targetStr) !== -1;
    }
    return sourceStr.includes(targetStr);
  }
  /** 用来翻译event中的多级路径 */
  get eventTranslatePlugin() {
    return new EventTranslatePlugin(this.translateFlow);
  }
  /** 搜索单个组件 */
  searchComps(comp) {
    const {
      translateFlow,
      translateProp,
      valueTranslate
    } = this.translateMap.get(comp.layout.type) || {};
    const layout = this.searchConfig.ShowDefault ? this.completeDefaultProps(comp.layout) : comp.layout;
    const pathBlackList = ['children', 'slots', 'scopedSlots'];
    const translateObj = {
      translatePath: {
        ...translateFlow,
        ...translateProp,
        ...specTranslate
      },
      translateValue: valueTranslate || {},
      translatePlugins: [this.eventTranslatePlugin, ...this.translatePluginList]
    };
    const searchAns = searchKeyInObjectDeep(this.searchInput, layout, this.matchKey.bind(this), translateObj, pathBlackList);
    return new SearchAnsGroupClass({
      searchAns,
      object: comp
    });
  }
  /** 通用的搜索 不带翻译 搜索path和value */
  searchInObjects(objects) {
    if (!objects) {
      return [];
    }
    return objects.map(object => {
      const searchAns = searchKeyInObjectDeep(this.searchInput, object, this.matchKey.bind(this), {
        translatePath: {},
        translateValue: {},
        translatePlugins: this.translatePluginList
      });
      return new SearchAnsGroupClass({
        searchAns,
        object
      });
    });
  }
  /** 通用的搜索 不带翻译 搜索path和value */
  searchInWalkObjects(objects) {
    if (!objects) {
      return [];
    }
    return objects.map(object => {
      const searchAns = searchKeyInObjectDeep(this.searchInput, object.object, this.matchKey.bind(this), {
        translatePath: {},
        translateValue: {},
        translatePlugins: this.translatePluginList
      });
      return new SearchAnsGroupClass({
        searchAns,
        object
      });
    });
  }
  /** 搜索时映射一下Triggers的名字 */
  searchTriggers(objects) {
    const watcherName = {
      'uc-watch-value': '数据变化监测器',
      'uc-timer': '定时触发'
    };
    const res = this.searchInComps(objects);
    // 补一个额外的name字段用来兜底
    res.forEach(value => {
      const objCloned = {
        ...value.object
      };
      // LayoutWalkStep 其实是没有name字段的 塞进去交给搜索来兜底了
      set(objCloned, 'name', watcherName[get(objCloned, 'layout.type')] || get(objCloned, 'layout.componentId'));
      value.object = objCloned;
    });
    return res;
  }
  /** 从string里搜出代码行数 */
  searchInString(sourceString) {
    if (!sourceString) {
      return [];
    }
    const strLineArray = sourceString.split('\n');
    const searchAns = searchStringInStringArray(this.searchInput, strLineArray, this.matchKey.bind(this));
    return [new SearchAnsGroupClass({
      searchAns,
      object: sourceString
    })];
  }
}
//# sourceMappingURL=PageletSearch.js.map
